import { FC } from "react";
import { Container } from "./styles";
import { Icon } from "Components/UI/Icon";

interface IModalHeader {
  title: string;
  onClose?: () => void;
}

const ModalHeader: FC<IModalHeader> = ({ title, onClose }) => {
  return (
    <Container>
      <span className="title">{title}</span>
      {onClose && (
        <Icon
          icon="cancelar"
          customSize={10}
          className="closeIcon"
          onClick={onClose}
        />
      )}
    </Container>
  );
};

export default ModalHeader;
